import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// 引入组件
import goods from '../view/userManage/user.vue'
import comments from '../view/shop/shop.vue'
import merchants from '../view/staff/staff.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    // redirect: 'login'
    name: '登录',
    component: () => import('../login.vue'),
    meta: {
      title: '登录页面'
    }
  },
  // {
  //   path: '/login',
  //
  // },
  {
    path: '/page',
    name: '首页',
    component: () => import('../page.vue')
  },
  {
    path: '/loginout',
    name: 'loginout',
    component: () => import('../login.vue'),
    meta: {
      title: '退出页面'
    }
  }
  // {
  //   path: '/',
  //   name: 'HelloWorld'
  //   // component: HelloWorld
  // }
]

export default new Router({
  routes,
  linkActiveClass: 'active'
})



// WEBPACK FOOTER //
// ./src/router/index.js